import { DiscountType } from "@/module/DiscountCode/DiscountType";

export default class DiscountCode {
  readonly id: number;
  readonly type: DiscountType;
  private readonly percentDiscount: number | null;
  private readonly discountAmounts: { [key: string]: number } | null;
  private readonly includingVat: boolean;

  constructor(
    id: number,
    type: DiscountType,
    percentDiscount: number | null,
    discountAmounts: { [key: string]: number } | null,
    includingVat: boolean,
  ) {
    this.id = id;
    this.type = type;
    this.percentDiscount = percentDiscount;
    this.discountAmounts = discountAmounts;
    this.includingVat = includingVat;
  }

  getPercentDiscount(): number {
    if (this.type !== DiscountType.PERCENT) {
      throw new Error("Discount does not have percent discount.");
    }

    return this.percentDiscount as number;
  }

  getPercentDiscountFraction(): number {
    return this.getPercentDiscount() / 100;
  }

  getDiscountAmount(currency: string): number | undefined {
    if (this.type !== DiscountType.CASH) {
      throw new Error("Discount does not have discount amount.");
    }

    if (this.discountAmounts === null) {
      return undefined;
    }

    return this.discountAmounts[currency];
  }

  isIncludingVat(): boolean {
    return this.includingVat;
  }

  isPercent(): boolean {
    return this.type === DiscountType.PERCENT;
  }
}
